import { Region } from "./region";

export class Comuna {
    id: string = "0";
    descripcion: string = "";
    region: Region = new Region();
}
